import { trackEvent } from '@/js/attribution/tracking';
import '@/sass/components/widgets/_hcp-widget.scss';
import '@/sass/components/widgets/hcp-product-tour-widget.scss';
class HCPWidget {
    constructor() {
        this.pressedCloseButtonOnce = false;
        this.contentElement = null;
        this.collapsibleContentElement = null;
        this.closeButtonElement = null;
        this.attributes = null;
        this.getElements();
        this.getAttributes();
        this.bindEvents();
    }
    getElements() {
        this.element = document.querySelector('.hcp-widget') || undefined;
        if (!this.element) {
            throw new Error('HCPWidget element not found');
        }
        this.contentElement = this.element.querySelector('.hcp-widget-content');
        this.collapsibleContentElement = this.element.querySelector('.hcp-widget-collapsible-content');
        this.closeButtonElement = this.element.querySelector('.hcp-widget-close-button');
    }
    getAttributes() {
        if (!this.element) {
            return;
        }
        this.attributes = {
            componentName: this.element.dataset?.component,
            collapsable: this.element.getAttribute('collapsable') === 'true',
        };
    }
    bindEvents() {
        if (!this.element) {
            return;
        }
        this.contentElement?.addEventListener('click', this.handleWidgetClick.bind(this));
        this.closeButtonElement?.addEventListener('click', this.handleCloseButtonClick.bind(this));
    }
    handleWidgetClick(event) {
        if (!this.element) {
            return;
        }
        this.toggleCollapsibleContent();
    }
    handleCloseButtonClick(event) {
        if (!this.element) {
            return;
        }
        this.pressedCloseButtonOnce = true;
        this.toggleCollapsibleContent();
        this.trackClick(event);
    }
    toggleCollapsibleContent() {
        if (!this.element) {
            return;
        }
        const isCollapsed = this.element.classList.contains('collapsed');
        if (isCollapsed) {
            this.expandWidget();
        }
        else {
            this.collapseWidget();
        }
    }
    expandWidget() {
        if (!this.element) {
            return;
        }
        // Opening: remove collapsed, add opening class for animation
        this.element.classList.remove('collapsed');
        this.element.classList.add('opening');
        this.collapsibleContentElement?.addEventListener('animationend', () => {
            this.element?.classList.remove('opening');
        }, { once: true });
        this.trackDialogViewed('opened');
    }
    collapseWidget() {
        if (!this.element) {
            return;
        }
        // Closing: add closing class, wait for animation, then add collapsed
        this.element.classList.add('closing');
        this.collapsibleContentElement?.addEventListener('animationend', () => {
            this.element?.classList.remove('closing');
            this.element?.classList.add('collapsed');
        }, { once: true });
        this.trackDialogViewed('closed');
    }
    showWidget() {
        if (!this.element || this.isVisible()) {
            return;
        }
        this.element.classList.add('show');
        this.trackDialogViewed('show');
    }
    hideWidget() {
        if (!this.element || !this.isVisible()) {
            return;
        }
        this.element.classList.remove('show');
        this.trackDialogViewed('hidden');
    }
    isExpanded() {
        return !this.element?.classList.contains('collapsed');
    }
    isVisible() {
        return this.element?.classList.contains('show') ?? false;
    }
    trackDialogViewed(action) {
        trackEvent('Dialog viewed', {
            action,
            wps_component: this.attributes?.componentName,
            pathname: window.location.pathname,
        });
    }
    trackClick(event) {
        if (!this.element) {
            return;
        }
        const button = event.currentTarget;
        const category = button.dataset.category || '';
        const name = button.dataset.name || button.getAttribute('name') || '';
        const componentName = this.attributes?.componentName || '';
        const label = button.getAttribute('label') || button.innerText || '';
        trackEvent('Click', {
            page_title: document.title || '',
            page_url: window.location.href || '',
            page_path: window.location.pathname || '',
            referrer: document.referrer || '',
            category,
            name: name.toLowerCase(),
            label: label.toLowerCase(),
            pathname: window.location.pathname || '',
            wps_component: componentName,
        });
    }
}
export default HCPWidget;
